import { getCustomerMainPerson, getLocaleFromCountryCode, isBusinessCustomer, isCustomerPendingActivation, } from '@raisin/cp-utils';
import { messages } from './messages';
export const getCustomerData = ({ customerData, mainCustomer, }) => {
    var _a;
    if (customerData) {
        const mappedProperties = {
            isCompanyCustomer: isBusinessCustomer(customerData),
            isPendingActivation: isCustomerPendingActivation(customerData),
            distributorId: (customerData === null || customerData === void 0 ? void 0 : customerData.distributorId) || '',
            fullName: '',
            firstName: (mainCustomer === null || mainCustomer === void 0 ? void 0 : mainCustomer.firstName) || '',
            lastName: (mainCustomer === null || mainCustomer === void 0 ? void 0 : mainCustomer.lastName) || '',
            locale: getLocaleFromCountryCode((_a = customerData === null || customerData === void 0 ? void 0 : customerData.address) === null || _a === void 0 ? void 0 : _a.countryCode),
        };
        return Object.assign(Object.assign(Object.assign({}, customerData), mainCustomer), mappedProperties);
    }
    return null;
};
export const getCustomerWithFullName = (customer, t) => {
    var _a;
    if (!customer || (customer === null || customer === void 0 ? void 0 : customer.fullName))
        return customer;
    const mainPerson = getCustomerMainPerson(customer);
    const academicTitleI18nId = messages[((_a = mainPerson === null || mainPerson === void 0 ? void 0 : mainPerson.personalDetails) === null || _a === void 0 ? void 0 : _a.academicTitleCode) || ''];
    const academicTitleTranslation = academicTitleI18nId ? t(academicTitleI18nId) : '';
    const fullName = [academicTitleTranslation, customer.firstName, customer.lastName]
        .filter((s) => s)
        .join(' ');
    return Object.assign(Object.assign({}, customer), { fullName });
};
//# sourceMappingURL=layoutMapper.js.map